module.exports = __webpack_public_path__ + "img/home3.3773bde6.png";